const DEFAULT_AMOUNT_FILTER = { value: "", minAmount: "", maxAmount: "" }

export default DEFAULT_AMOUNT_FILTER
